export const showMum = state => state.showMum
export const hintMsg = state => state.hintMsg
